import React, { useEffect, useState, useCallback } from "react";
import { useForm, FormProvider } from "react-hook-form";
//Material
import InputBase from "@material-ui/core/InputBase";
import Divider from "@material-ui/core/Divider";
import Paper from "@material-ui/core/Paper";
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
//Component
import { ReactTable } from "../../stories/react-table";
import { BaseContainer } from "../../stories/base-container";
import { BoxTemplate1 } from "../../stories/Box";
//Function
import * as api from "./api";
import * as alertDialog from "../../utils/alert";
import { getColumns } from "./columns/Column";
import { GetUser } from "../../utils/sessions";
import { useSelectRowOpenModal } from "../function-api/useSelectRowOpenModal";
import AddEditTemplateAuthorizeModal from "./add-edit-template-authorize";

const useStyles = makeStyles((theme) => ({
  rootSearch: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
    width: 500,
  },
  iconButton: {
    backgroundColor: "#000",
    color: "#fff",
  },
  iconButtonAdd: {
    backgroundColor: "#000",
    color: "#fff",
    marginRight: theme.spacing(2),
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  divider: {
    height: 28,
    margin: 4,
  },
}));

function ConfigTemplateAuthorize() {
  //State
  const classes = useStyles();
  //State
  const methodForm = useForm();
  const { register, getValues } = methodForm;

  const [DataList, setDataList] = useState([]);

  const [editMode, setEditMode] = useState(false);

  const {
    isOpen: openModalAddEdit,
    onOpen: onOpenModalAddEdit,
    onClose: onCloseModalAddEdit,
    Data: selectedData,
    handleClickRow: onClickRow,
  } = useSelectRowOpenModal();

  const fetch = useCallback(async () => {
    setDataList([]);
    const param = {
      TEXT_SEARCH: getValues()?.TEXT_SEARCH,
      USER_ID: GetUser(),
      MODE: "Refresh",
    };
    const res = await api.GetListTemplateAuthorize(param);
    setDataList(res);
  }, [getValues]);

  //Effect
  useEffect(() => {
    fetch();
  }, [fetch]);

  const onSearchText = async () => {
    fetch();
  };

  const onHandleEnter = (e) => {
    if (e.keyCode === 13) {
      onSearchText();
      e.preventDefault();
    }
  };

  const onEditTemplateAuthorize = (row) => {
    setEditMode(true);
    onClickRow(row);
  };

  const onDeleteTemplateAuthorize = async (userId) => {
    let res = await alertDialog.ConfirmDelete();
    if (!res) return;

    let param = {
      USER_ID: userId,
    };

    let api_res = await api.DeleteTemplateAuthorize(param);

    if (api_res.ResultCode === 10) {
      //Success
      fetch();
      alertDialog.del_success();
    } else {
      alertDialog.ErrorDialog("Error : " + res.Message);
    }
  };

  const tablecomponent = () => {
    return (
      <>
        <Button
          className={classes.iconButtonAdd}
          variant="contained"
          onClick={() => {
            setEditMode(false);
            onOpenModalAddEdit();
          }}
        >
          Add
        </Button>
      </>
    );
  };

  const searchcomponent = (searchProps) => {
    return (
      <>
        <Paper component="form" className={classes.rootSearch}>
          <InputBase
            className={classes.input}
            placeholder="Search"
            inputProps={{ "aria-label": "search" }}
            name="TEXT_SEARCH"
            inputRef={register}
            onKeyDown={(e) => onHandleEnter(e)}
          />
          <Divider className={classes.divider} orientation="vertical" />
          <Button
            variant="contained"
            className={classes.iconButton}
            onClick={onSearchText}
          >
            Search
          </Button>
        </Paper>
      </>
    );
  };

  return (
    <div>
      <BaseContainer maxWidth={false}>
        <BoxTemplate1 height="80vh" title="Config Template Authorize">
          <FormProvider {...methodForm}>
            <ReactTable
              keyField="USER_ID"
              data={DataList}
              columns={getColumns(
                onEditTemplateAuthorize,
                onDeleteTemplateAuthorize
              )}
              headcomponent={tablecomponent}
              showSearch={false}
              headRightcomponent={searchcomponent}
            />
          </FormProvider>
        </BoxTemplate1>
        <AddEditTemplateAuthorizeModal
          disableBackdropClick={true}
          open={openModalAddEdit}
          onClose={onCloseModalAddEdit}
          data={selectedData}
          editmode={editMode ? 1 : 0}
          fetchmain={fetch}
        />
      </BaseContainer>
    </div>
  );
}
export default ConfigTemplateAuthorize;
